import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontPagesComponent } from './front-pages.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FrontHeaderModule } from './Layouts/front-header/front-header.module';
import { FrontHomeComponent } from './pages/front-home/front-home.component';
import { FrontHeaderComponent } from './Layouts/front-header/front-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { FrontServicesPageComponent } from './pages/front-services-page/front-services-page.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { FrontFooterComponent } from './Layouts/front-footer/front-footer.component';

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    TranslateModule,
    
    
  ],
  declarations: [
    FrontPagesComponent, 
    FrontHomeComponent,
    FrontHeaderComponent,
    FrontServicesPageComponent,
    ComingSoonComponent,
    FrontFooterComponent
  ],
  exports: [FrontPagesComponent]
})
export class FrontPagesModule { }



// WEBPACK FOOTER //
// ./src/app/front-pages/front-pages.module.ts